import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import useTitle from 'react-use/lib/useTitle';

import {
  DashboardPageToolbar,
  DashboardToolbarHeading,
} from 'src/common/components/DashboardPageToolbar';
import { dashboardPageRootSx } from 'src/common/components/dashboardPageLayout';
import PageBox from 'src/common/components/PageBox';
import Box from '@mui/material/Box';
import ProfileEditorForm from './forms/ProfileEditorForm';

const Profile = () => {
  const { t } = useTranslation();

  useTitle(`${t('profile.pageTitle')} - ${t('base.defaultTitle')}`);

  return (
    <Box sx={dashboardPageRootSx}>
      <DashboardPageToolbar>
        <DashboardToolbarHeading>
          <Typography variant="h6" component="div">
            {t('profile.pageTitle')}
          </Typography>
        </DashboardToolbarHeading>
      </DashboardPageToolbar>
      <PageBox sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <ProfileEditorForm />
      </PageBox>
    </Box>
  );
};

export default Profile;
